<div>
    <div class="row">
        <div class="col-md-4">
            <span class="hipster img-fluid rounded"></span>
        </div>
        <div class="col-md-8">
            <h1 jhiTranslate="error.title">Error Page!</h1>

            <div [hidden]="!errorMessage">
                <div class="alert alert-danger">{{errorMessage}}
                </div>
            </div>
            <div [hidden]="!error403" class="alert alert-danger" jhiTranslate="error.http.403">
                You are not authorized to access this page.
                <div class="btn-wrapper mgt-15" >
                    <ion-button class="back-btn" fill="outline"  size="default" type="button"  role="button" expand="" (click)="backToHome()">Back To Home</ion-button>
                </div>
            </div>
            <div [hidden]="!error404" class="alert alert-danger" jhiTranslate="error.http.404">The page asked was not found.
                <div class="btn-wrapper mgt-15" >
                    <ion-button class="back-btn" fill="outline"  size="default" type="button"  role="button" expand="" (click)="backToHome()">Back To Home</ion-button>
                </div>
            </div>
        </div>
    </div>
</div>
